<template>
    <div class="p-4 bg-white rounded-[19px] shadow flex-col justify-start items-start gap-3 inline-flex sm:p-6">
        <div class="text-slate-700 text-xl font-extrabold">Details</div>

        <div class="flex flex-col gap-2 w-full">
            <div class="flex items-center gap-2">
                <span class="text-slate-500 text-sm">Vendor:</span>
                <vx-badge size="xs" color="slate">{{ vendorLabel }}</vx-badge>
            </div>

            <div class="flex items-center gap-2">
                <span class="text-slate-500 text-sm">Received:</span>
                <span class="text-sm">{{ shortDateTime(props.entry.timestamp) }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { VxBadge } from '@voxie/frontend-components';
import { computed } from 'vue';
import { shortDateTime } from '~/utils/date';
import type { IntegrationLogEntry } from '~/services/integrationLogsClient';

const props = defineProps<{
    entry: IntegrationLogEntry;
}>();

const vendorLabels: Record<string, string> = {
    acuity: 'Acuity',
    amplitude: 'Amplitude',
    calendly: 'Calendly',
    hubspot: 'HubSpot',
    jobber: 'Jobber',
    revel: 'Revel',
};

const vendorLabel = computed(() => vendorLabels[props.entry.vendor] ?? props.entry.vendor);
</script>
